@if (displayEstimates().length) {
  <section
    aria-label="Previous quotes"
    data-testid="previous-quotes-section"
    [class.previous-quotes-active]="isExpanded()"
    [class.previous-quotes]="!isExpanded()"
    [class.top-border]="showTopBorder()"
  >
    <button
      type="button"
      class="section-toggle"
      (click)="toggleSection()"
      [attr.aria-expanded]="isExpanded()"
      data-testid="previous-quotes-toggle"
    >
      <mat-icon class="chevron-icon" [class.chevron-expanded]="isExpanded()"
        >keyboard_arrow_right</mat-icon
      >
      <span class="section-title">Previous Quotes</span>
    </button>

    <div class="collapsible-content" [class.collapsed]="!isExpanded()">
      <div class="collapsible-inner">
        @for (
          estimate of displayEstimates();
          track trackEstimate(estimate, $index)
        ) {
          <app-quote-card
            [order]="order()"
            [estimate]="estimate"
            [isLowestStandard]="isLowestRate(estimate)"
            [readonlyMode]="true"
            data-testid="previous-quotes-card"
          />
        }
      </div>
    </div>
  </section>
} @else {
  <section
    class="previous-quotes previous-quotes--empty"
    [class.previous-quotes--empty-active]="isExpanded()"
    [class.top-border]="showTopBorder()"
    aria-label="Previous quotes"
    data-testid="previous-quotes-section"
  >
    <button
      type="button"
      class="section-toggle"
      (click)="toggleSection()"
      [attr.aria-expanded]="isExpanded()"
      data-testid="previous-quotes-toggle"
    >
      <mat-icon class="chevron-icon" [class.chevron-expanded]="isExpanded()"
        >keyboard_arrow_right</mat-icon
      >
      <span class="section-title">Previous Quotes</span>
    </button>

    <div class="collapsible-content" [class.collapsed]="!isExpanded()">
      <div
        class="collapsible-inner"
        [class.collapsible-inner-active]="isExpanded()"
      >
        <p
          class="previous-quotes__empty-message"
          data-testid="previous-quotes-empty"
        >
          No additional vendor quotes are available for this request.
        </p>
      </div>
    </div>
  </section>
}
